import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Skeleton from "react-loading-skeleton";
import ProductCard from "../common/ProductCard";
import type { TransformedProduct } from "../../types/productApiTypes";

interface RelatedProductsProps {
  products: TransformedProduct[];
  isLoading: boolean;
}

const RelatedProducts: React.FC<RelatedProductsProps> = ({
  products,
  isLoading,
}) => {
  const { t } = useTranslation("common");

  if (!isLoading && (!products || products.length === 0)) {
    return null;
  }

  return (
    <div className="related-products">
      {isLoading ? (
        <>
          <div className="related-products-title-skeleton-wrapper">
            <Skeleton
              height={30}
              width={200}
              style={{ marginBottom: "1rem" }}
              className="section-title-skeleton"
            />
          </div>
          <div className="related-products-loading">
            {[...Array(4)].map((_, index) => (
              <ProductCard.Skeleton key={index} />
            ))}
          </div>
        </>
      ) : (
        <>
          <h2 className="section-title">{t("relatedProducts.title")}</h2>
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={20}
            slidesPerView={1}
            className="related-products-carousel"
            breakpoints={{
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <ProductCard product={product} viewMode="grid" />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </div>
  );
};

export default RelatedProducts;
